import { CardLocationContextProvider } from 'crm-cards-sdk/internal/CardLocationContext';
import { DragDropComponentsProvider } from 'crm-cards-sdk/internal/DragDropComponentsContext';
import RequiredCrmContextProvider from 'crm-cards-sdk/internal/RequiredCrmContextProvider';
import { DefaultUsageTracker, MockUsageTracker } from 'crm-cards/internal/UsageTracker';
import { useEffect, useMemo } from 'react';
import MaybeSidebarCardLocationWrapper from './internal/sidebarCards/MaybeSidebarCardLocationWrapper';
import { PropertiesProvider } from 'customer-data-properties/context';
import { useLegacySidebarCardProps } from './internal/utils/useLegacySidebarCardProps';
import { LocationServiceProvider } from './internal/LocationServiceContext';
import { Metrics } from './internal/Metrics';
import { LocationStateContextProvider } from 'crm-cards-sdk/internal/perf/LocationStateContext';
import { jsx as _jsx } from "react/jsx-runtime";
const emptyLocationService = {};
export default function CrmCardFoundationProvider({
  disablePerfMetricLogging,
  additionalLocationData,
  disableUsageTracker = false,
  dragDropComponents,
  editableAreasAtom,
  features = [],
  gates,
  httpClient,
  i18nLoader,
  legacySidebarCardProps,
  location,
  locationService = emptyLocationService,
  loggingTag,
  propertySource = 'CRM_UI',
  scopes,
  supportLegacyCards = false,
  usageTracker = disableUsageTracker ? MockUsageTracker : DefaultUsageTracker,
  children,
  viewId,
  enableVirtualization = false,
  offscreenCardsPolicy = {
    type: 'DO_NOTHING'
  },
  updatedAt
}) {
  const renderStartedAtMs = useMemo(() => performance.now(), []);
  useEffect(() => {
    Metrics.counter('card-location-render', Object.assign({
      location
    }, loggingTag ? {
      logging_tag: loggingTag
    } : {})).increment();
  }, [location, loggingTag]);
  const locationContextValue = useMemo(() => ({
    additionalLocationData,
    editableAreasAtom,
    features: new Set(features),
    location,
    loggingTag,
    propertySource,
    usageTracker,
    viewId,
    enableVirtualization,
    offscreenCardsPolicy,
    updatedAt
  }), [additionalLocationData, editableAreasAtom, features, location, loggingTag, propertySource, usageTracker, viewId, enableVirtualization, offscreenCardsPolicy, updatedAt]);
  const extraCardProps = useLegacySidebarCardProps(legacySidebarCardProps);
  return /*#__PURE__*/_jsx(RequiredCrmContextProvider, {
    scopes: scopes,
    gates: gates,
    i18nLoader: i18nLoader,
    httpClient: httpClient,
    isInCrmLocation: true,
    children: /*#__PURE__*/_jsx(PropertiesProvider, {
      children: /*#__PURE__*/_jsx(CardLocationContextProvider, {
        value: locationContextValue,
        children: /*#__PURE__*/_jsx(LocationStateContextProvider, {
          disablePerfMetricLogging: disablePerfMetricLogging,
          location: location,
          loggingTag: loggingTag,
          renderStartedAtMs: renderStartedAtMs,
          isVirtualizationEnabled: enableVirtualization,
          children: /*#__PURE__*/_jsx(DragDropComponentsProvider, {
            value: dragDropComponents,
            children: /*#__PURE__*/_jsx(LocationServiceProvider, {
              value: locationService,
              children: /*#__PURE__*/_jsx(MaybeSidebarCardLocationWrapper, {
                scopes: scopes,
                gates: gates,
                supportLegacyCards: supportLegacyCards,
                legacySidebarCardProps: extraCardProps,
                children: children
              })
            })
          })
        })
      })
    })
  });
}